import {SecureService} from "@/services/superclasses/secure-service";
import {Currency} from "@/interfaces/currency";

const api = window.contextPath + '/rest/currencies';

export class CurrencySecureService extends SecureService {

    public loadSupported = async (): Promise<Currency[]> => {
        return this.data(await this.get<Currency[]>(api + "/supported"))
    }
}

export const currencySecureService = new CurrencySecureService()